<template>
  <UDrawer
    v-model:open="open"
    direction="right"
    :dismissible="false"
    :description="$t('checkr_processes.description')"
    :ui="{ content: 'max-w-3xl', header: 'relative' }"
  >
    <!-- dismissible=false quita click-afuera/Escape a propósito, así que
    sin esto el usuario queda sin forma de cerrar el drawer. -->
    <template #title>
      {{ $t('checkr_processes.object_name_plural') }}
      <UButton
        icon="i-lucide-x"
        color="neutral"
        variant="soft"
        size="sm"
        class="absolute top-3 right-3 rounded-full"
        :title="$t('common.action.close')"
        @click="open = false"
      />
    </template>
    <template #body>
      <div class="flex flex-col gap-3">
        <div v-if="showGoToPage" class="flex justify-end">
          <UButton variant="solid" class="bg-3a-btn add h-7" style="font-size:12px" @click="goToAiInspections()">
            <UIcon name="i-lucide-external-link" /> {{ $t('checkr_processes.go_to_ai_inspections') }}
          </UButton>
        </div>
        <CatalogsCheckrProcessList @select="(process) => emit('select', process)" />
      </div>
    </template>
  </UDrawer>
</template>

<script lang="ts" setup>
import type { ExternalProcessSummary } from '~/types/integrations/externalProcess'

withDefaults(defineProps<{ showGoToPage?: boolean }>(), { showGoToPage: true })

const open = defineModel<boolean>('open', { default: false })

const emit = defineEmits<{ (e: 'select', process: ExternalProcessSummary): void }>()

function goToAiInspections()
{
  open.value = false
  navigateTo(AI_INSPECTIONS_PATH)
}
</script>
